import cricket from './definition.js';
import { createClosingGameController } from '../shared/closing-game-controller.js';

export default createClosingGameController(cricket);
